import React from "react";
import "../Poster/Poster.css";
import { Link } from "react-router-dom";

const PosterSection = () => {
  return (
    <div className="poster-section">
      <div className="poster-video">
        <video autoPlay loop muted playsInline>
          <source src="/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="poster-image">
        <img src="/pckpost.webp" alt="Poster" />
        <div className="overlay-content">
          <p className="overlay-subheading">Experience the Difference</p>
          <h1 className="overlay-heading">Crafted with Excellence</h1>
          <Link to="/contactus">
            <button className="contact-button">Contact Us</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PosterSection;
